import { ref } from 'vue'
import { gsap } from 'gsap'

// Menu
const fastlinks = ref({
  isOpen : false
});

const useFastlinks = {
  open() {
    const fastLink = document.querySelector('.FastLinks')

    gsap.to(fastLink, { y: 0, duration: 0.8, ease: 'expo.out', onStart: () => {
      fastlinks.value.isOpen = true
      document.body.classList.add('showFastlinks')
      document.body.style.overflow = "hidden"
      document.body.classList.add('is--animating')
    }, onComplete: () => {
      document.body.classList.remove('is--animating')
    }})
  },
  close() {
    const fastLink = document.querySelector('.FastLinks')
    const contentHeight = fastLink.querySelector('.inner').offsetHeight

    gsap.to(fastLink, { y: contentHeight + 5 , duration: 0.8, ease: 'expo.out', onStart: () => {
      fastlinks.value.isOpen = false
      document.body.classList.remove('showFastlinks')
      document.body.classList.add('is--animating')
      document.body.style.overflow = ""
    }, onComplete: () => {
      document.body.classList.remove('is--animating')
    }})
  }
};

export { fastlinks, useFastlinks }
